import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import { useNavigate } from "react-router";
import _ from "lodash";
import {
  ProductCardPriceInfo,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
} from "../../../utils/AppUtils";
import {
  getUsefulVideos,
  getUsefulVideosClear,
} from "../../../redux/video/actions";
import CommonComponentEntity from "./CommonComponentEntity";
import { getUsefulCoursesClear } from "../../../redux/courses/actions";

const UsefulVideos = ({fetchData}) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const usefulCoursesDataResponse = useSelector(
    (state) => state.video.usefulVideos
  );

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (fetchData) {
      getUsefulVideosData();
    }
    // return () => {
    //   dispatch(getUsefulVideosClear());
    // };
  }, [fetchData]);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const navigateToView = (video) => {
    let paramsReq ={
      code: video?.crscd,
      source: _.lowerCase(
        video?.source
      ),
      is_paid: video?.priceInfo.isFree ,
      is_home: true
    }
    if (!_.isEmpty(video.categoryId)) {
      paramsReq.catId = video?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    // let url = `/video-view-page/${video?.product_id}/?source=${_.lowerCase(
    //   video?.source
    // )}&code=${video?.crscd}&is_paid=${video?.priceInfo.isFree}`;
    // if (!_.isEmpty(video.categoryId)) {
    //   url += `&catId=${video?.categoryId[0]}`;
    // }
    let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
    navigate(url);
  };
  const formatProductCardData = (coursesList) => {
    let prodArr = [];

    for (let video of coursesList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";

      logoURL = video.provider?.provider_img;
      tags.push(video?.provider?.display_name);
      tags.push("Video");
      tags.push(`${video.views} View${video.views > 1 ? "s" : ""}`);
      if (video.second) {
        tags.push(convertTimeFormat(video.second, true));
      }

      let priceInfo = getProcureInfo(video.purchased_info);
      video.priceInfo = priceInfo;

      prodArr.push({
        id: video?.product_id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        is_wishlist: video?.is_addtowishlist,
        dbId: video?.list_id,
        productType: video?.type,
        productOrigin: video?.source,
        title: video.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video.thumbnail,
        tagsArray: tags,
        description: video.long_description,
        duration: convertTimeFormat(video.second, true),
        showHeader: true,
        showLikeMenu: true,
        showProviderIcon: true,
        showPlayButton: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(video),
        descAction: () => {},
        bannerAction: () => navigateToView(video),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        view: video.views,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        isLoading: false,
      });
    }
    console.log("PROD ARR", prodArr);
    setNewCardData(prodArr);
  };

  useEffect(() => {
    if (!_.isEmpty(usefulCoursesDataResponse)) {
      if (usefulCoursesDataResponse.status === "success") {
        const list1 = usefulCoursesDataResponse.payload.payload?.list;
        if (!_.isEmpty(list1)) {
          formatProductCardData(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [usefulCoursesDataResponse]);

  const getUsefulVideosData = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getUsefulVideos({
        module: "usefulVideos",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_type: "video",
          origin: "xsel",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        // isLoading={isLoading}
        newCardData={newCardData}
        heading={"Videos you may find useful"}
        subHeading={"Based on what other learners are watching"}
        viewAllAction={"/learn/videos"}
        type={"video"}
      />
    </>
  );
};

export default UsefulVideos;
